<div class="d-flex flex-column">
    <p-divider></p-divider>
    <div class="d-flex">
        <mat-form-field class="">
            <mat-label>Enter promo code</mat-label>
            <input matInput #promoCodeValue type="text" name="promoCodeValue" [(ngModel)]="promoCode" />
        </mat-form-field>
        <p-button [disabled]="!promoCode" pRipple styleClass="p-button-raised p-button-success m-2" (click)="validate()">
            <ng-template pTemplate="content">
                <div class="d-flex justify-content-center">
                    Apply
                </div>
            </ng-template>
        </p-button>
    </div>
    
</div>